import { useMemo } from 'react'

export type UseQueryContext = {
  isContextCheckout: boolean
  isContextMigrate: boolean
}

const useQueryContext = (): UseQueryContext => {
  // Indicates page should display checkout specific copy
  const CONTEXT_CHECKOUT = 'checkout'
  // Indicates page should display migrate specific copy
  const CONTEXT_MIGRATE = 'migrate'

  const params = new URLSearchParams(window.location.search)
  const contextParam = params.get('context')

  const isContextCheckout = useMemo(
    () => contextParam === CONTEXT_CHECKOUT,
    [contextParam]
  )
  const isContextMigrate = useMemo(
    () => contextParam === CONTEXT_MIGRATE,
    [contextParam]
  )

  return {
    isContextCheckout,
    isContextMigrate,
  }
}

export default useQueryContext
